import { render, staticRenderFns } from "./Banking.vue?vue&type=template&id=37343af9&scoped=true"
import script from "./Banking.vue?vue&type=script&lang=js"
export * from "./Banking.vue?vue&type=script&lang=js"
import style0 from "./Banking.vue?vue&type=style&index=0&id=37343af9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37343af9",
  null
  
)

export default component.exports